import React from 'react';
import { Box } from '@chakra-ui/react';

export const OnlineIndicator = () => (
  <Box
    background="#47BF12"
    border="2px solid rgba(71, 191, 18, 0.15)"
    borderRadius="50%"
    backgroundClip="padding-box"
    w="12px"
    h="12px"
  />
);
